// Selección de un motor para un portamotor, con rechazo explicado. Ver docs/theory/motors.md.
import { MOTOR_FIT_TOLERANCE } from '../rocket/motor';
import { listMounts, setMountMotor } from '../rocket/mounts';
import type { Rocket } from '../rocket/types';
import type { Motor } from './motor';

export type SelectResult =
  | { readonly ok: true; readonly rocket: Rocket; readonly warnings: readonly string[] }
  | { readonly ok: false; readonly error: string };

const TOL = 1e-9;
const mm = (m: number): string => `${(m * 1000).toFixed(1)} mm`;

/** Asigna `motor` al portamotor `mountId` (id del tubo); rechaza motores más anchos o más largos que el tubo. */
export function selectMotor(rocket: Rocket, mountId: string, motor: Motor, ejectionDelay: number): SelectResult {
  const found = listMounts(rocket).find((m) => m.tube.id === mountId);
  if (found === undefined) return { ok: false, error: `No existe el soporte de motor ${mountId}` };
  if (!Number.isFinite(ejectionDelay) || ejectionDelay < 0) return { ok: false, error: 'El retardo de eyección debe ser mayor o igual que cero' };
  if (motor.diameter > found.innerDiameter + MOTOR_FIT_TOLERANCE) {
    return { ok: false, error: `El motor ${motor.designation} (${mm(motor.diameter)}) es más ancho que el soporte (${mm(found.innerDiameter)})` };
  }
  if (motor.length > found.length + (found.mark.overhang ?? 0) + TOL) {
    return { ok: false, error: `El motor ${motor.designation} (${mm(motor.length)}) es más largo que el soporte (${mm(found.length)})` };
  }

  const warnings: string[] = [];
  if (motor.delays.length > 0 && !motor.delays.includes(ejectionDelay)) {
    warnings.push(`El retardo ${ejectionDelay} s no es uno de los que ofrece el motor (${motor.delays.join(', ')} s)`);
  }

  return { ok: true, rocket: setMountMotor(rocket, mountId, { motorId: motor.id, ejectionDelay }), warnings };
}
